import { ContactCmsContent } from '../models/types';

export const CONTACT_CMS_IDENTIFIER = 'contact-page';

export const DEFAULT_CONTACT_CMS: ContactCmsContent = {
  badge: 'Get in Touch',
  title: 'Contact Us',
  subtitle:
    'Have a question, partnership inquiry, or need support? Send us a message and our team will get back to you.',
  generalInquiries: {
    title: 'General Inquiries',
    description:
      'For product questions, integrations, or general support — fill out the form and attach any relevant screenshots or documents.',
  },
  community: {
    title: 'Community',
    description: 'Join our community channels for real-time updates and discussions.',
  },
  attachmentGuidelines: {
    title: 'Attachment Guidelines',
    items: [
      'Accepted: JPG, PNG, GIF, PDF, DOC, DOCX',
      'Maximum file size: 10 MB',
      'Include screenshots for technical issues',
    ],
  },
  form: {
    emailLabel: 'Email Address',
    emailPlaceholder: 'Enter your Email Address',
    subjectLabel: 'Subject',
    subjectPlaceholder: 'Enter your Subject',
    messageLabel: 'Message',
    messagePlaceholder: 'Enter your Message',
    attachmentLabel: 'Attachment',
    attachmentPlaceholder: 'Choose a file (required)',
    verificationText:
      'I confirm that I am not a robot and agree to be contacted regarding this inquiry.',
    submitButton: 'Send Message',
    submittingButton: 'Sending...',
  },
  seo: {
    metaTitle: 'Contact Us | DEX',
    metaDescription: 'Contact the DEX team for support, partnerships, and general inquiries.',
    keywords: 'dex, contact, support, defi help',
    ogImage: '',
  },
};

export const parseContactCmsContent = (content?: string): ContactCmsContent => {
  if (!content) return DEFAULT_CONTACT_CMS;

  try {
    const parsed = typeof content === 'string' ? JSON.parse(content) as Partial<ContactCmsContent> : content as Partial<ContactCmsContent>;
    const fallback = DEFAULT_CONTACT_CMS;
    return {
      ...fallback,
      ...parsed,
      generalInquiries: { ...fallback.generalInquiries, ...parsed.generalInquiries },
      community: { ...fallback.community, ...parsed.community },
      attachmentGuidelines: {
        ...fallback.attachmentGuidelines,
        ...parsed.attachmentGuidelines,
        items: parsed.attachmentGuidelines?.items?.length
          ? parsed.attachmentGuidelines.items
          : fallback.attachmentGuidelines.items,
      },
      form: { ...fallback.form, ...parsed.form },
      seo: { ...fallback.seo, ...parsed.seo },
    };
  } catch {
    return DEFAULT_CONTACT_CMS;
  }
};
